<template>
  <div class="page">
    <div class="no-data">
      <img class="pictrue" src="@assets/images/no_card.png" />
      <div class="title">对不起，该练习暂无章节~</div>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  data: function() {
    return {
    };
  },
  created() {
    this.init();
  },
  methods: {
    init(){
    }
  }
};
</script>
<style lang="scss" scoped>
.page {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #F5F5F5;

  .no-data{
    margin: 20px auto;
    padding: 28px 18px;
    width: 92%;
    height: 260px;
    text-align: center;
    background: #fff;
    border-radius: 5px;

    .pictrue{
      width: 122px;
      height: 104px;
    }

    .title{
      margin-top: 15px;
      font-size: 16px;
      color:#999;
    }
  }

}
</style>
